import { dbExecute, dbSelect, isTauri } from "./db";

// SQL Schema de tabelas para SQLite local
const SCHEMA = [
  `CREATE TABLE IF NOT EXISTS system_settings (
    key TEXT PRIMARY KEY,
    value TEXT
  );`,

  `CREATE TABLE IF NOT EXISTS condominiums (
    id TEXT PRIMARY KEY,
    name TEXT NOT NULL,
    address TEXT,
    created_at TEXT
  );`,

  `CREATE TABLE IF NOT EXISTS units (
    id TEXT PRIMARY KEY,
    condominium_id TEXT NOT NULL,
    number TEXT NOT NULL,
    building TEXT,
    block TEXT,
    created_at TEXT
  );`,

  `CREATE TABLE IF NOT EXISTS profiles (
    id TEXT PRIMARY KEY,
    condominium_id TEXT,
    email TEXT,
    full_name TEXT,
    phone TEXT,
    cpf TEXT,
    role TEXT CHECK (role IN ('morador', 'porteiro', 'sindico', 'administracao', 'superadmin')),
    apartment_number TEXT,
    building TEXT,
    is_active INTEGER DEFAULT 1,
    password_hash TEXT,
    created_at TEXT
  );`,

  `CREATE TABLE IF NOT EXISTS visitors (
    id TEXT PRIMARY KEY,
    condominium_id TEXT,
    name TEXT NOT NULL,
    document TEXT,
    phone TEXT,
    photo_url TEXT,
    notes TEXT,
    status TEXT DEFAULT 'active',
    unit_id TEXT,
    authorized_by TEXT,
    vehicle_plate TEXT,
    visit_date TEXT,
    visitor_type TEXT,
    entry_time TEXT,
    exit_time TEXT,
    created_at TEXT
  );`
];

// Inicialização do banco de dados (roda no startup)
export const initializeDatabase = async (): Promise<boolean> => {
  try {
    console.log("[DB Init] Iniciando verificação de banco SQLite...");
    
    // Executa cada query do Schema
    for (const sql of SCHEMA) {
      await dbExecute(sql);
    }
    
    console.log("[DB Init] Tabelas SQLite garantidas com sucesso.");
    
    // Verifica se já existe condomínio configurado localmente
    const checkCondo = await dbSelect<{ id: string }>("SELECT id FROM condominiums LIMIT 1");
    
    if (checkCondo.length === 0) {
      console.log("[DB Init] Banco de dados vazio. Requer sincronização inicial e ativação de licença.");
      
      // Insere um registro inicial padrão para evitar quebras se rodando fora de ambiente com licença (como web de desenvolvimento)
      if (!isTauri()) {
        await dbExecute(
          `INSERT OR IGNORE INTO condominiums (id, name, address, created_at) 
           VALUES ('demo-condo', 'Condomínio Demonstrativo Local', 'Rua Principal, 123', datetime('now'))`
        );
        await dbExecute(
          `INSERT OR IGNORE INTO system_settings (key, value) 
           VALUES ('license_status', 'active')`
        );
        await dbExecute(
          `INSERT OR IGNORE INTO system_settings (key, value) 
           VALUES ('license_key', 'DEMO-LICENSE-KEY-1234')`
        );
      }
    }
    
    return true;
  } catch (error) {
    console.error("[DB Init] Erro fatal ao inicializar o banco SQLite:", error);
    return false;
  }
};
